import React, { useState, useEffect, useCallback } from "react";
import {
  Alert,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
  Table,
} from "reactstrap";
import DatePickerMulti from "react-multi-date-picker";
import { Button } from "reactstrap";
import { BiCalendarAlt, BiCheck, BiHash, BiRecycle, BiX } from "react-icons/bi";
import { BsChevronDown, BsDownload, BsStars } from "react-icons/bs";
import moment from "moment";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import parse from "react-html-parser";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import MultirangeDatePickerDesigned from "./MultirangeDatePickerDesigned";
import { CSVLink } from "react-csv";
import { FaThumbsUp } from "react-icons/fa6";
import {
  ATTEMPT_NO_FILTER,
  CUSTOM_QUESTION_INPUT_TYPES,
  formatDuration,
  getAttemptNumberFilterOptions,
  getInputTypeLabel,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  minPlanLimitCheck,
  sentimentPercent,
  SENTIMENTS_TYPO_MAP,
  shouldMaskForAnonymity,
} from "../data";
import {
  contvertHTMLToPlain,
  profilePicValidityCheck,
} from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import Select from "react-select";
import { toastContainer } from "../../../utils/toast";
import { marked } from "marked";
import { MdBusAlert, MdUpgrade } from "react-icons/md";

import SummaryPieChart from "./SummaryPieChart";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";
import TrivvyDropoffsModal from "./TrivvyDropoffsModal";
import GreyOutUpgradePlanuBlockUi from "../../../components/Shared/GreyOutUpgradePlanuBlockUi";
import TriviaResultsResponses from "./TriviaResultsResponses";
import Plot from "../../../utils/customPlotly";
import LinearNumericBarGraph from "./Results/LinearNumericBarGraph";
import TextSentimentComponent from "./Results/TextSentimentComponent";
import TextSentimentComponentOverall from "./Results/TextSentimentComponentOverall";
import TriviaInsightsV2 from "./TriviaInsightsV2";
import TriviaQuestionHeader from "./TriviaQuestionHeader";
import OptionsPiechart from "./Results/OptionsPiechart";
import placeHolderInsights from "../../../assets/trivvy/placeholder_insights.png";

function TriviaResultsSummary({
  questions,
  surveyId,
  allowAttempts,
  currentTrivvy,
  setCurrentTrivia,
  user,
}) {
  const [dateRange, setDateRange] = useState([new Date()]);
  const [attemptNumber, setAttemptNumber] = useState(0);
  const [summaryApiLoading, setSummaryApiLoading] = useState(false);
  const [openDropOffModal, setOpenDropOffModal] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [openSubmissionModal, setOpenSubmissionsModal] = useState(false);
  const [surveyInsights, setSurveyInsights] = useState(
    currentTrivvy.surveyInsights || {}
  );
  const [v2FullInsightsMap, setV2FullInsightsMap] = useState({});
  const [v2InsightsLoading, setV2InsightsLoading] = useState(false);
  const [v2ExpandedMap, setV2ExpandedMap] = useState({});

  useEffect(()=>{
    setSurveyInsights(currentTrivvy.surveyInsights)
 },[currentTrivvy])
  const handleDateChange = (value) => {
    const items = value.map((x) => new Date(x));
    setDateRange(items);
    if (items.length == 2 || items.length == 0) {
      getSummaryData({
        attempts: attemptNumber,
        dates: items,
      });
    }
  };

  const [isFiltersApplied, setIsFilterApplied] = useState(false);
  const [insightsLoading, setInsightsLoading] = useState(false);

  const trivvyHasSingleTextQuestion =
    currentTrivvy && currentTrivvy.questions
      ? currentTrivvy.questions.filter((x) => x.question_type == "TEXT")
        .length > 0
      : false;

  const isMcQTrivvy =
    questions && questions.filter((x) => x.question_type == "MCQ").length > 0;
  const [summaryData, setSummaryData] = useState({});
  const getSummaryData = (filters) => {
    setSummaryApiLoading(true);
    axios
      .post(url.getTriviaInsightsSummary(surveyId), { filter: filters })
      .then(({ data }) => {
        setSummaryApiLoading(false);
        let doc = {};
        if (filters != null) {
          setIsFilterApplied(true);
          doc = { ...data.data };
          if (!doc.submitted_docs) {
            doc.submitted_docs = 0;
          }
          if (!doc.started_docs) {
            doc.started_docs = 0;
          }
          if (!doc.question_responses_records) {
            doc.question_responses_records = [];
          }
          if (!doc.option_response_matching_records) {
            doc.option_response_matching_records = [];
          }
          if (
            !doc.sentiment_data ||
            (doc.sentiment_data && !doc.sentiment_data.sentiment)
          ) {
            doc.sentiment_data = null;
          } else {
          }
        } else {
          setIsFilterApplied(false);
          doc.started_docs = data.data.started_docs || 0;
          doc.submitted_docs = currentTrivvy.totalSubmissions || 0;
        }
        setSummaryData(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // getSummaryData(null);
  }, []);

  let total_people_counts = 0;

  if (currentTrivvy) {
    total_people_counts = (currentTrivvy.insightsTotalCount && currentTrivvy.insightsTotalCount > 0)
      ? currentTrivvy.insightsTotalCount
      : (currentTrivvy.otherMediumsShareCount || 0);
  }
 

  const getDataForSummary = useCallback(() => {
    if (
      summaryData &&
      questions &&
      questions.length &&
      (isFiltersApplied ||
        (summaryData.question_responses_records &&
          summaryData.question_responses_records.length))
    ) {
      const questionAnswerArray = questions.map((question) => {
        const object = {
          question: `${contvertHTMLToPlain(question.question_text)} ${getInputTypeLabel(question.question_type)
              ? `(${getInputTypeLabel(question.question_type)})`
              : ""
            }`,
          answer:
            question.correct_options && question.correct_options[0]
              ? question.correct_options[0].text
              : "None",
        };

        let questionResCount = 0;
        const question_doc = isFiltersApplied 
          ?  summaryData.question_responses_records && summaryData.question_responses_records.find(
            (x) => x._id === question.question_id
          )
          : { ...question };

        if (!question_doc) {
          questionResCount = 0;
        } else {
          questionResCount = question_doc.totalResponses;
        }

        let isRangeQuestion = false;
        let rangeAverage = 0;
        let isCustomTextQuestion = false;
        let remainingTextQuestions = 0;
        let maxAvgLimit = 0;

        if (question.question_type == "LINEAR_NUMERIC") {
          maxAvgLimit = question.linearNumericConfigs
            ? question.linearNumericConfigs.max || 0
            : 0;
        }

        if (question_doc && question_doc.userResponses) {
          const userResponses = [...question_doc.userResponses];

          if (
            userResponses[0] &&
            userResponses[0].question_type == "LINEAR_NUMERIC"
          ) {
            isRangeQuestion = true;

            const selectedAnswersStrings = [];

            for (const res of userResponses) {
              if (res.selected_answers && res.selected_answers[0]) {
                selectedAnswersStrings.push(res.selected_answers[0].text);
              }
            }

            const selectedAnswersNums = selectedAnswersStrings.map((x) => {
              try {
                return parseInt(x);
              } catch (error) {
                return 0;
              }
            });

            const totalSum = selectedAnswersNums.reduce(
              (accumulator, currentValue) => {
                return accumulator + currentValue;
              },
              0
            );

            rangeAverage = parseFloat(
              totalSum / selectedAnswersNums.length
            ).toFixed(2);
          } else if (
            userResponses[0] &&
            userResponses[0].question_type == "TEXT"
          ) {
            isCustomTextQuestion = true;
            remainingTextQuestions = total_people_counts - questionResCount;
          }
        } else {
          if (question.question_type === "LINEAR_NUMERIC") {
            isRangeQuestion = true;

            const selectedAnswersStrings =
              question.linearNumericResponsesCounts &&
                Object.keys(question.linearNumericResponsesCounts).length
                ? Object.values(question.linearNumericResponsesCounts)
                : [];

            const selectedAnswersNums = selectedAnswersStrings.map((x) => {
              try {
                return parseInt(x);
              } catch (error) {
                return 0;
              }
            });

            const totalSum = selectedAnswersNums.reduce(
              (accumulator, currentValue) => {
                return accumulator + currentValue;
              },
              0
            );

            rangeAverage = parseFloat(
              totalSum / selectedAnswersNums.length
            ).toFixed(2);
          } else if (question.question_type === "TEXT") {
            isCustomTextQuestion = true;
            remainingTextQuestions = total_people_counts - questionResCount;
          }
        }

        if (question.question_type != "MCQ") {
          if (question.question_type == "TEXT") {
            object["answer"] = `Responded${Math.round(
              (questionResCount / total_people_counts) * 100
            )}% (${questionResCount})`;
          }
          if (question.question_type == "LINEAR_NUMERIC") {
            object["answer"] = `${rangeAverage}/ ${question.linearNumericConfigs
                ? question.linearNumericConfigs.max
                : ""
              } (${questionResCount}) `;
          }
        }

        for (let index = 0; index < question.options.length; index++) {
          const option = question.options[index];

          let optionResCount = 0;
          const option_doc = isFiltersApplied
            ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
              (x) => x._id === option.option_id
            )
            : option;

          if (!option_doc) {
            optionResCount = 0;
          } else {
            optionResCount =
              option_doc.totalResponses || option_doc.totalResponded;
          }
          const progressVal =
            questionResCount > 0
              ? Math.round((optionResCount / questionResCount) * 100)
              : 0;
          object[`option${index + 1}`] = `${progressVal}% (${optionResCount})`;
        }
        return object;
      });

      const finalData = [];

      for (let index = 0; index < questions.length; index++) {
        if (index == 0) {
          finalData.push({
            dropOffs: summaryData.started_docs,
            submissions: summaryData.submitted_docs,
            completionRate: ` ${Math.round(
              (summaryData.submitted_docs /
                (summaryData.submitted_docs + summaryData.started_docs)) *
              100
            )} %`,
            averageTime: summaryData.total_avg_time
              ? `${parseFloat(summaryData.total_avg_time).toFixed(2)} sec`
              : "0 sec",
            ...questionAnswerArray[index],
          });
        } else {
          finalData.push({
            dropOffs: "",
            submissions: "",
            completionRate: "",
            averageTime: "",
            ...questionAnswerArray[index],
          });
        }
      }

      return finalData;
    } else {
      return [];
    }
  }, [summaryData]);

  const summarizeCustomQuestionAnswers = (questionId) => {
    axios
      .post(url.sumarizeTextInputResponses, {
        triviaId: surveyId,
        questionId,
      })
      .then(({ data }) => {
        setCurrentTrivia({
          ...currentTrivvy,
          questions: data.data.questions,
        });
      })
      .catch((err) => {
        toastContainer("Error while generating summary");
      });
  };

  const [isEndDateBeforeToday, setIsEndDateBeforeToday] = useState(false);

  useEffect(() => {
    if (currentTrivvy) {
      if (!currentTrivvy.trivvyEndDate) {
        setIsEndDateBeforeToday(true);
      }
      else if (moment(currentTrivvy.trivvyEndDate).isSameOrBefore(moment(), "day")) {
        setIsEndDateBeforeToday(true);
      }
    }
  }, [currentTrivvy]);

  const trivvyPlanType =
    user && user.organizationId && user.organizationId.trivvyPlanType;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const consturctUserObjForExternalUser = (obj) => {
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: "[Email]-",
      };
    } else if (obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: "[Name]-",
        firstName: arr[0],
        lastName: arr[1] || "",
      };
    } else {
      return {
        identification: "[EmployeeId]-",

        firstName: obj.employeeId,
      };
    }
  };
  const renderUserName = (data) => {
    if (!data.isAnonymous) {
      if (data.userId && data.userId._id) {
        return (
          <span className="trivia_table_text_wrapper">
            {profilePicValidityCheck(data.userId.profilePic) ? (
              <img
                src={data.userId.profilePic}
                height="35px"
                width="35px"
                style={{ borderRadius: "50%" }}
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={getInitials(data.userId)}
              ></span>
            )}{" "}
            {data.userId.firstName} {data.userId.lastName}
          </span>
        );
      } else if (data.userData) {
        return (
          <span>
            {consturctUserObjForExternalUser(data.userData).firstName}{" "}
            {consturctUserObjForExternalUser(data.userData).lastName}
          </span>
        );
      } else {
        return "User";
      }
    } else {
      return "Anonymous user";
    }
  };

  const isNonMcQTrivvy =
    questions &&
    questions.filter(
      (x) =>
        x.question_type == "MCQ" && x.correct_options && x.correct_options[0]
    ).length == 0;

  const generateTextQuestionInsights = (questionId, isRegenerate) => {
    setInsightsLoading(true);
    axios
      .post(url.generateInsightsForTextTrivvyQuestion, {
        triviaId: currentTrivvy._id,
        questionId,
        regenerate: isRegenerate,
        oldText: surveyInsights ? surveyInsights[questionId] : "",
      })
      .then(({ data }) => {
        setInsightsLoading(false);
        if (data && data.success && data.insights) {
          const completedDoc = data.insights;
          setV2FullInsightsMap({
            ...v2FullInsightsMap,
            [questionId]: completedDoc,
          });
          const overview =
            completedDoc.parts && completedDoc.parts.overview
              ? completedDoc.parts.overview.content || ""
              : "";
          const themes =
            completedDoc.parts && completedDoc.parts.keyThemes && completedDoc.parts.keyThemes.themes
              ? completedDoc.parts.keyThemes.themes.map((t) => t.label)
              : [];
          const actions =
            completedDoc.parts && completedDoc.parts.recommendedActions && completedDoc.parts.recommendedActions.actions
              ? completedDoc.parts.recommendedActions.actions.map((a) => a.action)
              : [];
          const risks =
            completedDoc.parts && completedDoc.parts.risks && completedDoc.parts.risks.items
              ? completedDoc.parts.risks.items.map((r) => r.description)
              : [];
          const indexEntry = {
            questionId,
            status: "COMPLETED",
            overview,
            themes,
            actions,
            risks,
          };
          const existingIndex = currentTrivvy.insightsIndex || [];
          const newIndex = existingIndex.filter((e) => e.questionId !== questionId);
          newIndex.push(indexEntry);
          setCurrentTrivia({
            ...currentTrivvy,
            insightsVersion: 2,
            insightsIndex: newIndex,
          });
        }
      })
      .catch((err) => {
        setInsightsLoading(false);
        console.log(err);
      });
  };

  const getFullInsightsForQuestion = (questionId) => {
    setV2InsightsLoading(true);
    axios
      .get(url.getInsightsForTextTrivvyQuestion(currentTrivvy._id, questionId))
      .then(({ data }) => {
        setV2InsightsLoading(false);
        if (data.success && data.insights) {
          setV2FullInsightsMap({
            ...v2FullInsightsMap,
            [questionId]: data.insights,
          });
        }
      })
      .catch((err) => {
        setV2InsightsLoading(false);
        console.log(err);
      });
  };

  // Toggle expand/collapse for v2 insights. If the full insights have not
  // been fetched yet, fetch them and auto-expand; otherwise just flip the
  // expanded flag without re-fetching.
  const handleToggleV2Insights = (questionId) => {
    if (v2FullInsightsMap[questionId]) {
      setV2ExpandedMap((prev) => {
        const next = { ...prev };
        next[questionId] = !prev[questionId];
        return next;
      });
    } else {
      setV2ExpandedMap((prev) => {
        const next = { ...prev };
        next[questionId] = true;
        return next;
      });
      getFullInsightsForQuestion(questionId);
    }
  };

  const generatePDF = async () => {
    setIsGeneratingPDF(true);

    const pdfTarget = document.getElementById('pdf_content_container');
  
    // Ensure the content is visible just before rendering
    pdfTarget.style.display = 'block';
  
    // Wait one frame to ensure browser paints the content
    // await new Promise((resolve) => requestAnimationFrame(resolve));
  
    await window.html2pdf()
      .from(pdfTarget)
      .set({
        margin: 0.5,
        filename: `Trivvy_Questions_Summary_${new Date().toISOString()}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      })
      .save();
  
    // Clean up: hide it again
    pdfTarget.style.display = 'none';
    setIsGeneratingPDF(false);

  };
  
  console.log('rendering results here')

  const renderPDFContent = () => {
    return (
      <div className="mt-3 trivvy-questions-results-container">
            <div className="mt-3 trivvy-questions-results-container">
            {summaryApiLoading ? (
              <SpinnerLoader />
            ) : summaryData && questions && questions.length > 0 ? (
              <div className="mt-2" style={{ width: "100%" }}>
                {questions.map((question) => {
                  const correct_optionId =
                    question.correct_options[0] &&
                    question.correct_options[0].option_id;
                  let questionResCount = 0;
                  const question_doc =
                    isFiltersApplied && summaryData.question_responses_records
                      ? summaryData.question_responses_records.find(
                        (x) => x._id === question.question_id
                      )
                      : question;
                  if (!question_doc) {
                    questionResCount = 0;
                  } else {
                    questionResCount =
                      question_doc.totalResponses ||
                      question_doc.users_responded;
                  }
                  const odd_or_eve = question.order % 2 == 0 ? "even" : "odd";
                  let isRangeQuestion = false;
                  let rangeAverage = 0;
                  let isCustomTextQuestion = false;
                  let remainingTextQuestions = 0;
                  let maxAvgLimit = 0;
                  let scaleCountObject = {};
                  let totalSumOfNumResponses = 0;
                  let sentimentCountObject = {
                    POSITIVE: 0,
                    NEGATIVE: 0,
                    NEUTRAL: 0,
                  };

                  for (
                    let index = question.linearNumericConfigs.min - 1;
                    index < question.linearNumericConfigs.max;
                    index++
                  ) {
                    scaleCountObject[index + 1] = 0;
                  }

                  console.log({ scaleCountObject });

                  if (question.question_type == "LINEAR_NUMERIC") {
                    maxAvgLimit = question.linearNumericConfigs
                      ? question.linearNumericConfigs.max || 0
                      : 0;
                  }

                  if (question_doc && question_doc.userResponses) {
                    const userResponses = [...question_doc.userResponses];

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type === "TEXT"
                    ) {
                      for (const res of userResponses) {
                        if (
                          res.textSentimentsData &&
                          res.textSentimentsData.sentiment
                        ) {
                          if (
                            res.textSentimentsData &&
                            ["POSITIVE", "NEGATIVE", "NEUTRAL"].includes(
                              res.textSentimentsData.sentiment
                            )
                          ) {
                            sentimentCountObject[
                              res.textSentimentsData.sentiment
                            ] += 1;
                            totalSumOfNumResponses += 1;
                          }
                        }
                      }
                    }

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type == "LINEAR_NUMERIC"
                    ) {
                      isRangeQuestion = true;

                      const selectedAnswersStrings = [];

                      for (const res of userResponses) {
                        if (res.selected_answers && res.selected_answers[0]) {
                          selectedAnswersStrings.push(
                            res.selected_answers[0].text
                          );

                          totalSumOfNumResponses += 1;

                          scaleCountObject[
                            parseInt(res.selected_answers[0].text)
                          ] += 1;
                        }
                      }

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = parseFloat(
                        totalSum / selectedAnswersNums.length
                      ).toFixed(2);
                    } else if (
                      userResponses[0] &&
                      userResponses[0].question_type == "TEXT"
                    ) {
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  } else if (questionResCount > 0) {
                    totalSumOfNumResponses = question.users_responded;
                    if (question.question_type === "LINEAR_NUMERIC") {
                      isRangeQuestion = true;

                      const selectedAnswersStrings =
                        question.linearNumericResponsesCounts &&
                          Object.keys(question.linearNumericResponsesCounts)
                            .length
                          ? Object.values(question.linearNumericResponsesCounts)
                          : [];

                      if (
                        question.linearNumericResponsesCounts &&
                        Object.keys(question.linearNumericResponsesCounts)
                          .length
                      ) {
                        for (
                          let index = question.linearNumericConfigs.min - 1;
                          index < question.linearNumericConfigs.max;
                          index++
                        ) {
                          scaleCountObject[index + 1] =
                            question.linearNumericResponsesCounts[index + 1];
                        }
                      }

                      console.log({ scaleCountObject, selectedAnswersStrings });

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = parseFloat(
                        totalSum / selectedAnswersNums.length
                      ).toFixed(2);
                    } else if (question.question_type === "TEXT") {
                      sentimentCountObject = question.sentimentCounts;
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  }

                  const minScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.min
                    : 0;
                  const maxScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.max
                    : 0;

                  const xData = [];
                  const yData = [];

                  const sortedObj = Object.keys(scaleCountObject)
                    .sort((a, b) => a - b) // Sort the keys numerically
                    .reduce((acc, key) => {
                      acc[key] = scaleCountObject[key];
                      return acc;
                    }, {});

                  console.log("itmmmmm", sortedObj);
                  for (const itm in sortedObj) {
                    xData.push(parseInt(itm));
                    yData.push(sortedObj[itm]);
                  }

                  // The card-top TriviaQuestionHeader below renders for every
                  // question type (incl. TEXT), so the header always shows — even
                  // at 0 responses or when anonymity-masked. TEXT also renders the
                  // v2 insights card for the body; its own header is suppressed via
                  // hideHeader to avoid a duplicate. isV2TextQuestion now only gates
                  // the legacy "Responded : X%" span; the legacy v1 placeholder path
                  // is no longer reachable for TEXT questions.
                  const isV2TextQuestion = question.question_type === "TEXT";

                  return (
                    <div className="trivia_result_summary_question_card">
                      <TriviaQuestionHeader
                        question={question}
                        responseCount={questionResCount || 0}
                        totalRespondents={total_people_counts || 0}
                      />
                      {isRangeQuestion && question.users_responded ? (
                        <LinearNumericBarGraph
                          yScales={yData}
                          xScales={xData}
                          totalSumOfNumResponses={totalSumOfNumResponses}
                        />
                      ) : (
                      <div className="trivia_result_summary_question_card_top_questionwrapper">
                        <div className="question_text">
                          <div className="summary_total_avg" >
                            {isCustomTextQuestion ? (
                              <div>
                                {!isV2TextQuestion && (
                                  <span>
                                    Responded :{" "}
                                    {Math.round(
                                      (questionResCount / total_people_counts) *
                                      100
                                    )}
                                    %
                                  </span>
                                )}

                                <div className="my-2">
                                  {(() => {
                                    const v2Entry = currentTrivvy.insightsIndex
                                      ? currentTrivvy.insightsIndex.find(x => x.questionId === question.question_id)
                                      : null;
                                    const v2Full = v2FullInsightsMap[question.question_id];
                                    const sentimentNode = currentTrivvy && question.question_type == "TEXT" &&
                                      question.averageSentimentsScore &&
                                      question.averageSentimentsScore.positive >= 0 ? (
                                      <TextSentimentComponentOverall
                                        questionId={question.question_id}
                                        totalSentimentCounts={sentimentCountObject}
                                        data={question.averageSentimentsScore}
                                        totalSumOfNumResponses={totalSumOfNumResponses}
                                        user={user}
                                        currentTrivvy={currentTrivvy}
                                      />
                                    ) : null;
                                    return (
                                      <TriviaInsightsV2
                                        question={question}
                                        questionOrder={question.order}
                                        questionText={question.question_text}
                                        responseCount={questionResCount || 0}
                                        totalRespondents={total_people_counts || 0}
                                        insightEntry={v2Entry}
                                        insights={v2Full}
                                        isExpanded={!!v2ExpandedMap[question.question_id]}
                                        isLoading={v2InsightsLoading || insightsLoading}
                                        canGetFullInsights={!!v2Entry}
                                        canRegenerate={!!v2Entry || !!(surveyInsights && surveyInsights[question.question_id])}
                                        canGenerate={!v2Entry && !(surveyInsights && surveyInsights[question.question_id])}
                                        onGetFullInsights={() => handleToggleV2Insights(question.question_id)}
                                        onRegenerate={() => generateTextQuestionInsights(question.question_id, true)}
                                        onGenerate={() => generateTextQuestionInsights(question.question_id, false)}
                                        sentimentNode={sentimentNode}
                                        hideHeader
                                      />
                                    );
                                  })()}
                                </div>

                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      )}

                      {currentTrivvy.isBuiltInWithAiType &&
                        question.question_type == "MCQ" &&
                        question.options &&
                        questionResCount > 0 &&
                        currentTrivvy.totalSubmissions ? (
                        <div className={`trivia_result_summary_question_card_options_wrapper mt-3 ${!isMobile ? "mx-5  px-3" : ""}  `}>
                          {/* Pie chart */}
                          <OptionsPiechart
                            isFiltersApplied={isFiltersApplied}
                            question={question}
                            option_response_matching_records={
                              summaryData.option_response_matching_records ||[]
                            }
                          />
                        </div>
                      ) : (
                        <div className="trivia_result_summary_question_card_options_wrapper mx-5 mt-3 px-3">
                          {question.question_type == "MCQ" &&
                            questionResCount > 0 &&
                            question.options &&
                            question.options.map((option, indx) => {
                              let optionResCount = 0;
                              const option_doc = isFiltersApplied
                                ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
                                  (x) => x._id === option.option_id
                                )
                                : option;

                              if (!option_doc) {
                                optionResCount = 0;
                              } else {
                                optionResCount =
                                  option_doc.totalResponses ||
                                  option_doc.totalResponded;
                              }
                              const progressVal =
                                questionResCount > 0
                                  ? Math.round(
                                    (optionResCount / questionResCount) * 100
                                  )
                                  : 0;
                              return (
                                <div
                                  style={{
                                    marginBottom: "20px",
                                  }}
                                  key={indx}
                                >
                                  <div className={"option_text_result_wrapper"}>
                                    {correct_optionId == option.option_id ? (
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {parse(option.text)} (answer){" "}
                                        <FaThumbsUp size="15" />
                                      </span>
                                    ) : (
                                      <span>{parse(option.text)}</span>
                                    )}

                                    <div>
                                      <span className="small_secondary_text">
                                        {optionResCount} resp.
                                      </span>

                                      <span className="ml-2">
                                        {progressVal}%
                                      </span>
                                    </div>
                                  </div>

                                  <div>
                                    <Progress
                                      className={
                                        progressVal == 100
                                          ? "optionResProgress progressCompleted"
                                          : "optionResProgress"
                                      }
                                      color="primary"
                                      value={progressVal}
                                    ></Progress>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <EmptyTable
                title={"No data found"}
                subtitle={"No responses have been collected."}
              />
            )}
          </div>
      </div>
    );
  };
  
  console.log(
    currentTrivvy.allowAnonymousResponses,
    "currentTrivvy.allowAnonymousResponses"
  );

  return (
    <div className="res-stats-summary">

   

      <div className="d-flex justify-content-center mt-3">
        <MultirangeDatePickerDesigned
          dateRange={dateRange}
          handleDateChange={handleDateChange}
          headingText={"Responses"}
          
         
        />


    

      </div>
      


      <div className="d-flex">
        {/* <div className="ml-3">
          {summaryData &&
          summaryData.question_responses_records &&
          summaryData.question_responses_records.length &&
          questions ? (
            <CSVLink
              data={getDataForSummary()}
              headers={summaryHeaders}
              filename={`Trivvy Summary-${moment().format("MM/DD/YYYY")}.csv`}
              separator={","}
              target="_blank"
              className="ml-2 btn trivia-action-button-main h-fitcontent trivvy-export-table-btn"
            >
              Export to CSV <BsDownload size={13} />
            </CSVLink>
          ) : (
            ""
          )}
        </div> */}

        {allowAttempts > 0 && currentTrivvy ? (
          <Select
            options={getAttemptNumberFilterOptions(
              currentTrivvy.numberOfAttempts
            )}
            className="ml-4 select-trivvy-attempt-filter"
            placeholder={"Select attempt number"}
            value={attemptNumber}
            onChange={(e) => {
              setAttemptNumber(e.value);
              getSummaryData({
                dates: dateRange,
                attempts: e.value,
              });
            }}
          />
        ) : (
          ""
        )}
      </div>

      <div>
        <div className="pt-3 pb-2">
          <div>
            {/* <h2
                style={{
                  fontWeight: 300,
                }}
              >
                Big Picture
              </h2> */}
          </div>

          <div id="pdf_content_container" style={{ display: 'none' }}>
            {renderPDFContent()} {/* Render your questions block here */}
          </div>

          <div className="mt-3 trivvy-questions-results-container">
            {summaryApiLoading ? (
              <SpinnerLoader />
            ) : summaryData && questions && questions.length > 0 ? (
              <div className="mt-2" style={{ width: "100%" }}>
                {questions.map((question) => {
                  const correct_optionId =
                    question.correct_options[0] &&
                    question.correct_options[0].option_id;
                  let questionResCount = 0;
                  const question_doc =
                    isFiltersApplied && summaryData.question_responses_records
                      ? summaryData.question_responses_records.find(
                        (x) => x._id === question.question_id
                      )
                      : question;
                  if (!question_doc) {
                    questionResCount = 0;
                  } else {
                    questionResCount =
                      question_doc.totalResponses ||
                      question_doc.users_responded;
                  }
                  const odd_or_eve = question.order % 2 == 0 ? "even" : "odd";
                  let isRangeQuestion = false;
                  let rangeAverage = 0;
                  let isCustomTextQuestion = false;
                  let remainingTextQuestions = 0;
                  let maxAvgLimit = 0;
                  let scaleCountObject = {};
                  let totalSumOfNumResponses = 0;
                  let sentimentCountObject = {
                    POSITIVE: 0,
                    NEGATIVE: 0,
                    NEUTRAL: 0,
                  };

                  for (
                    let index = question.linearNumericConfigs.min - 1;
                    index < question.linearNumericConfigs.max;
                    index++
                  ) {
                    scaleCountObject[index + 1] = 0;
                  }

                  console.log({ scaleCountObject });

                  if (question.question_type == "LINEAR_NUMERIC") {
                    maxAvgLimit = question.linearNumericConfigs
                      ? question.linearNumericConfigs.max || 0
                      : 0;
                  }

                  if (question_doc && question_doc.userResponses) {
                    const userResponses = [...question_doc.userResponses];

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type === "TEXT"
                    ) {
                      for (const res of userResponses) {
                        if (
                          res.textSentimentsData &&
                          res.textSentimentsData.sentiment
                        ) {
                          if (
                            res.textSentimentsData &&
                            ["POSITIVE", "NEGATIVE", "NEUTRAL"].includes(
                              res.textSentimentsData.sentiment
                            )
                          ) {
                            sentimentCountObject[
                              res.textSentimentsData.sentiment
                            ] += 1;
                            totalSumOfNumResponses += 1;
                          }
                        }
                      }
                    }

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type == "LINEAR_NUMERIC"
                    ) {
                      isRangeQuestion = true;

                      const selectedAnswersStrings = [];

                      for (const res of userResponses) {
                        if (res.selected_answers && res.selected_answers[0]) {
                          selectedAnswersStrings.push(
                            res.selected_answers[0].text
                          );

                          totalSumOfNumResponses += 1;

                          scaleCountObject[
                            parseInt(res.selected_answers[0].text)
                          ] += 1;
                        }
                      }

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = parseFloat(
                        totalSum / selectedAnswersNums.length
                      ).toFixed(2);
                    } else if (
                      userResponses[0] &&
                      userResponses[0].question_type == "TEXT"
                    ) {
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  } else if (questionResCount > 0) {
                    totalSumOfNumResponses = question.users_responded;
                    if (question.question_type === "LINEAR_NUMERIC") {
                      isRangeQuestion = true;

                      const selectedAnswersStrings =
                        question.linearNumericResponsesCounts &&
                          Object.keys(question.linearNumericResponsesCounts)
                            .length
                          ? Object.values(question.linearNumericResponsesCounts)
                          : [];

                      if (
                        question.linearNumericResponsesCounts &&
                        Object.keys(question.linearNumericResponsesCounts)
                          .length
                      ) {
                        for (
                          let index = question.linearNumericConfigs.min - 1;
                          index < question.linearNumericConfigs.max;
                          index++
                        ) {
                          scaleCountObject[index + 1] =
                            question.linearNumericResponsesCounts[index + 1];
                        }
                      }

                      console.log({ scaleCountObject, selectedAnswersStrings });

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = parseFloat(
                        totalSum / selectedAnswersNums.length
                      ).toFixed(2);
                    } else if (question.question_type === "TEXT") {
                      sentimentCountObject = question.sentimentCounts;
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  }

                  const minScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.min
                    : 0;
                  const maxScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.max
                    : 0;

                  const xData = [];
                  const yData = [];

                  const sortedObj = Object.keys(scaleCountObject)
                    .sort((a, b) => a - b) // Sort the keys numerically
                    .reduce((acc, key) => {
                      acc[key] = scaleCountObject[key];
                      return acc;
                    }, {});

                  console.log("itmmmmm", sortedObj);
                  for (const itm in sortedObj) {
                    xData.push(parseInt(itm));
                    yData.push(sortedObj[itm]);
                  }

                  // The card-top TriviaQuestionHeader below renders for every
                  // question type (incl. TEXT), so the header always shows — even
                  // at 0 responses or when anonymity-masked. TEXT also renders the
                  // v2 insights card for the body; its own header is suppressed via
                  // hideHeader to avoid a duplicate. isV2TextQuestion now only gates
                  // the legacy "Responded : X%" span; the legacy v1 placeholder path
                  // is no longer reachable for TEXT questions.
                  const isV2TextQuestion = question.question_type === "TEXT";

                  return (
                    <div className="trivia_result_summary_question_card">
                      <TriviaQuestionHeader
                        question={question}
                        responseCount={questionResCount || 0}
                        totalRespondents={total_people_counts || 0}
                      />
                      {isRangeQuestion && question.users_responded && !(shouldMaskForAnonymity(currentTrivvy, currentTrivvy.totalSubmissions) && currentTrivvy.totalSubmissions > 0) ? (
                        <LinearNumericBarGraph
                          yScales={yData}
                          xScales={xData}
                          totalSumOfNumResponses={totalSumOfNumResponses}
                        />
                      ) : (
                      <div className="trivia_result_summary_question_card_top_questionwrapper">
                        <div className="question_text">
                            {  shouldMaskForAnonymity(currentTrivvy, currentTrivvy.totalSubmissions) && currentTrivvy.totalSubmissions > 0 ? (
                              <div style={{
                                fontSize:'16px',margin:"10px 0px"
                              }}>
                                Too few responses to maintain anonymity
                                </div>) : (

                          <div className="summary_total_avg">
                            {isCustomTextQuestion ? (
                              <div>
                                {!isV2TextQuestion && (
                                  <span>
                                    Responded :{" "}
                                    {Math.round(
                                      (questionResCount / total_people_counts) *
                                      100
                                    )}
                                    %
                                  </span>
                                )}

                                <div className="my-2">
                                  {(() => {
                                    const v2Entry = currentTrivvy.insightsIndex
                                      ? currentTrivvy.insightsIndex.find(x => x.questionId === question.question_id)
                                      : null;
                                    const v2Full = v2FullInsightsMap[question.question_id];
                                    const sentimentNode = currentTrivvy && question.question_type == "TEXT" &&
                                      question.averageSentimentsScore &&
                                      question.averageSentimentsScore.positive >= 0 ? (
                                      <TextSentimentComponentOverall
                                        questionId={question.question_id}
                                        totalSentimentCounts={sentimentCountObject}
                                        data={question.averageSentimentsScore}
                                        totalSumOfNumResponses={totalSumOfNumResponses}
                                        user={user}
                                        currentTrivvy={currentTrivvy}
                                      />
                                    ) : null;
                                    return (
                                      <TriviaInsightsV2
                                        question={question}
                                        questionOrder={question.order}
                                        questionText={question.question_text}
                                        responseCount={questionResCount || 0}
                                        totalRespondents={total_people_counts || 0}
                                        insightEntry={v2Entry}
                                        insights={v2Full}
                                        isExpanded={!!v2ExpandedMap[question.question_id]}
                                        isLoading={v2InsightsLoading || insightsLoading}
                                        canGetFullInsights={!!v2Entry}
                                        canRegenerate={!!v2Entry || !!(surveyInsights && surveyInsights[question.question_id])}
                                        canGenerate={!v2Entry && !(surveyInsights && surveyInsights[question.question_id])}
                                        onGetFullInsights={() => handleToggleV2Insights(question.question_id)}
                                        onRegenerate={() => generateTextQuestionInsights(question.question_id, true)}
                                        onGenerate={() => generateTextQuestionInsights(question.question_id, false)}
                                        sentimentNode={sentimentNode}
                                        hideHeader
                                      />
                                    );
                                  })()}
                                </div>

                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                                )}
                        </div>
                      </div>
                      )}

                      {!(shouldMaskForAnonymity(currentTrivvy, currentTrivvy.totalSubmissions) &&
                          currentTrivvy.totalSubmissions > 0) &&  currentTrivvy.isBuiltInWithAiType &&
                        question.question_type == "MCQ" &&
                        question.options &&
                        questionResCount > 0 &&
                        currentTrivvy.totalSubmissions ? (
                        <div className={`trivia_result_summary_question_card_options_wrapper mt-3 ${!isMobile ? "mx-5  px-3" : ""}  `}>
                          {/* Pie chart */}
                          <OptionsPiechart
                            isFiltersApplied={isFiltersApplied}
                            question={question}
                            option_response_matching_records={
                              summaryData.option_response_matching_records ||[]
                            }
                          />
                        </div>
                      ) : (
                        !(shouldMaskForAnonymity(currentTrivvy, currentTrivvy.totalSubmissions) &&
                          currentTrivvy.totalSubmissions > 0) &&
                        <div className="trivia_result_summary_question_card_options_wrapper mx-5 mt-3 px-3">
                          {question.question_type == "MCQ" &&
                            questionResCount > 0 &&
                            question.options &&
                            question.options.map((option, indx) => {
                              let optionResCount = 0;
                              const option_doc = isFiltersApplied
                                ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
                                  (x) => x._id === option.option_id
                                )
                                : option;

                              if (!option_doc) {
                                optionResCount = 0;
                              } else {
                                optionResCount =
                                  option_doc.totalResponses ||
                                  option_doc.totalResponded;
                              }
                              const progressVal =
                                questionResCount > 0
                                  ? Math.round(
                                    (optionResCount / questionResCount) * 100
                                  )
                                  : 0;
                              return (
                                <div
                                  style={{
                                    marginBottom: "20px",
                                  }}
                                  key={indx}
                                >
                                  <div className={"option_text_result_wrapper"}>
                                    {correct_optionId == option.option_id ? (
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {parse(option.text)} (answer){" "}
                                        <FaThumbsUp size="15" />
                                      </span>
                                    ) : (
                                      <span>{parse(option.text)}</span>
                                    )}

                                    <div>
                                      <span className="small_secondary_text">
                                        {optionResCount} resp.
                                      </span>

                                      <span className="ml-2">
                                        {progressVal}%
                                      </span>
                                    </div>
                                  </div>

                                  <div>
                                    <Progress
                                      className={
                                        progressVal == 100
                                          ? "optionResProgress progressCompleted"
                                          : "optionResProgress"
                                      }
                                      color="primary"
                                      value={progressVal}
                                    ></Progress>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <EmptyTable
                title={"No data found"}
                subtitle={"No responses have been collected."}
              />
            )}
          </div>
        
        
        </div>
      </div>
    </div>
  );
}

export default TriviaResultsSummary;
